import { UserRole } from './models';

export const UserRoleName: { [key in UserRole]: string } = {
  support: 'Support',
  super_admin: 'Super Admin',
  admin: 'Admin',
  prompt_engineer: 'Prompt Engineer',
  editor: 'Editor',
};
